import _ from 'lodash';

import filters from '../core/filters';
import translate from '../core/tools/translate';

import { CoreControl } from './CoreControl';
import { VectorType } from './VectorType';

export class CitiesControl extends CoreControl {
    constructor () {
        super({ name: 'Cities' });

        this._change = this._change.bind(this);
        this._filterCallback = this._filterCallback.bind(this);
        this.createFilter = this.createFilter.bind(this);
    }

    static getInstance () {
        if (!CitiesControl._instance) {
            CitiesControl._instance = new CitiesControl();
        }

        return CitiesControl._instance;
    }

    init () {
        const values = {
            help: translate(`Help.MainCity`),
            id: 'layer-cities',
            input: 'checkbox',
            label: translate('Common.MainCity'),
            layer: this.getLayer,
            change: this._change,
            filter: this.createFilter,
            name: this.options.name,
            type: 'vector-points'
        };

        if (!this._instance) {
            this._instance = new VectorType(values);
        }
    }

    createFilter () {
        filters.create({
            id: `${_.kebabCase(this.options.name)}-filter-id`,
            label: translate('Common.MainCity'),
            type: _.lowerCase(this.options.name),
            onSubmit: this._filterCallback
        });
    }

    _change (e) {
        super._change(e);
        this._setFilterButtonVisibility(e.checked);
    }

    _setFilterButtonVisibility (state) {
        try {
            this.getControls().button.filter.input.enable(state);
            this.getControls().button.filter.enable = state;

            state ? this.createFilter() : filters.close();
        } catch (err) {
            console.log('ERROR: ', err);
        }
    }

    _filterCallback (values) {
        const layer = this.getLayer();
        const remote = layer.options.remote;

        const demography = values.demography.value.split(':');
        remote.params.minDemography = Number(demography[0]);
        remote.params.maxDemography = Number(demography[1]);

        const registrations = values.registrations.value.split(':');
        remote.params.minRegistrations = Number(registrations[0]);
        remote.params.maxRegistrations = Number(registrations[1]);

        const domicilesTarget = values.domicilesTarget.value.split(':');
        remote.params.minDomicilesTarget = Number(domicilesTarget[0]);
        remote.params.maxDomicilesTarget = Number(domicilesTarget[1]);

        const startMonth = values.month.value[0];
        const endMonth = values.month.value[1];
        const startDate = `${values.year.value}${startMonth < 10 ? `0${startMonth}` : startMonth}`;
        const endDate = `${values.year.value}${endMonth < 10 ? `0${endMonth}` : endMonth}`;
        remote.params.startDate = startDate;
        remote.params.endDate = endDate;

        layer.setOptions({ remote });
        layer.redraw();
    }
}

export default CitiesControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/CitiesControl.js